module.exports = __webpack_public_path__ + "static/media/mail-icon.86ec2442.svg";